import type { OrgSettings } from '@shared/types';
import { SYSTEM_ORG_IDS } from '../business/org';

export const DEFAULT_ORG_SETTINGS: OrgSettings = {
    orgId: SYSTEM_ORG_IDS.NOT_APPLICABLE,
    name: '',
    defaultCountryCode: 'AU',
    allowedCountryCodes: ['AU'],
    allowAllCountryCodes: false,
    logoUrl: '',
    navLogoDisplay: 'NAME_ONLY',
} as const;
